import React, {lazy, Suspense,useState,useEffect,useRef,useContext} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { CardPerso, Loading} from "@gull";
import FacturationNew from "../../../Pdf/FacturationNew"
import DetailAndButton from './DetailAndButton'
import { Tabs, Tab } from "react-bootstrap";
import SearchBilling from '../../SearchBilling'
import PreviousNextBtn from './DetailButton/PreviousNextBtn'
import { IsAuthContext } from 'app/App';
import { withLogoHeader } from "app/views/facturation/datatable_facture_tools";

const DetailTableDocPo = lazy(() => import('../DetailTableDocPo'));
const DetailTableDocReturnNote = lazy(() => import('../DetailTableDocReturnNote'));
const DetailTableDoc = lazy(() => import('../DetailTableDoc'));
const ReliquatTableDocPo = lazy(() => import('../ReliquatTableDocPo'));

const Contain = (props) => {
    const t = useTranslate();
    return(<>
        {Object.keys(props.allInfos).length!=0 ? 
            <div className="row">
                <div className="col-5">
                    <DetailAndButton
                        allInfos={props.allInfos}
                        clientDetail={props.clientDetail}
                        showEdit={props.showEdit}
                        setShowEdit={props.setShowEdit}
                        cancelInvoice={props.cancelInvoice}
                        validIndividualButton={props.validIndividualButton}
                        convertQuotationToInvoice={props.convertQuotationToInvoice}
                        validateDeliveryNote={props.validateDeliveryNote}
                        convertDeliveryNoteToInvoice={props.convertDeliveryNoteToInvoice}
                        id={props.id}
                        setId={props.setId}
                        setTitleDocument={props.setTitleDocument}
                        setItemsBilling={props.setItemsBilling}
                        setAllInfos={props.setAllInfos}
                        constructionDocument={props.constructionDocument}
                        columnShow={props.columnShow}
                        recapShow={props.recapShow}
                        setColumnShow={props.setColumnShow}
                        setRecapShow={props.setRecapShow}
                        duplicateDocument={props.duplicateDocument}
                        company={props.company}
                        moduleFacturation={props.moduleFacturation}
                        setDatasPdf={props.setDatasPdf}
                        setBrownDocumentModal={(props.setBrownDocumentModal) ? props.setBrownDocumentModal : false}
                        from={props.from}
                    />
                </div>
                <div className='col-7'>
                    {/* {(props.from=='modal') &&
                        <div className='d-flex justify-content-end'>
                            <button
                                className='btn btn-success btn-sm'
                                onClick={() => props.downloadPDF()}
                            >
                                {t('dlThePdf')}
                            </button>
                        </div>
                    } */}
                    {(Object.keys(props.allInfos).length!=0) ?
                        <div className='position-relative'>
                            <iframe
                                ref={props.iframeRef}
                                width="100%"
                                height="1000px"
                                title="Aperçu du PDF"
                                style={{ border: 'none'}}
                            ></iframe>
                        </div>
                        :
                        false                              
                    }
                </div>
            </div>
        :
            false
        }
    </>)
}

const ViewDetailDocument = (props) =>{
    const t = useTranslate();
    const { authParam } = useContext(IsAuthContext);
    const iframeRef = useRef(null);
    const moduleFacturation = authParam.modules.find(value=>value.name=='invoice')
    const [reloadReliquat,setReloadReliquat]=useState(false)
    const [pdfBase64, setPdfBase64] = useState(null);
    const [loadingDetail,setLoadingDetail] = useState(false)
    const tabSelect = (eventKey) => {
        if (eventKey === 'reliquat') {
            setReloadReliquat(Date.now())
        }
        if (eventKey === 'detail') {
            props.constructionDocument(setLoadingDetail, props.id, false, t, {with_stock:true}, props.setItemsBilling, props.setAllInfos)
        }
        if (eventKey === 'consult') {
            console.log('load')
            props.constructionDocument(setLoadingDetail, props.id, false, t, {with_stock:false}, props.setItemsBilling, props.setAllInfos)
        }
    };

    useEffect(() => {
            // Définir un délai en millisecondes
            const delay = 500; // Par exemple, 500 ms
            let pdfUrl = null;
            setPdfBase64(null)
            if(props.setPdf){
                props.setPdf(null)
            }
            // Utiliser setTimeout pour retarder l'exécution
            const timer = setTimeout(async () => {
                const pdfBlob = await FacturationNew({
                    t: t,
                    documentType: props.allInfos.type,
                    companyInfos: props.companyInfos,
                    // billing: props.itemsBilling,
                    billing: props.allInfos.facture_article_list_pdf ?? props.datasPdf,
                    clientDetail: props.clientDetail,
                    devise: props.devise,
                    digit: props.digit,
                    allInfos: props.allInfos,
                    columnShow: props.columnShow,
                    recapShow: props.recapShow,
                    moduleFacturation: moduleFacturation
                });

                // Convertir le PDF Blob en Base64
                const reader = new FileReader();
                reader.onloadend = () => {
                    // Mettre à jour l'état avec la chaîne Base64
                    setPdfBase64(reader.result.replace('data:application/pdf;base64,',''));
                };
                
                if(props.setPdf){
                    props.setPdf(pdfBlob)
                }

                // Lire le Blob comme une Data URL (Base64)
                reader.readAsDataURL(pdfBlob);
        
                pdfUrl = URL.createObjectURL(pdfBlob);
                // setPdfBlob(pdfUrl)
                if (iframeRef.current) {
                    iframeRef.current.src = pdfUrl;
                }
            }, delay);
        
            // Nettoyage de l'effet pour annuler le timer en cas de changement rapide de columnShow
            return () => {
                clearTimeout(timer);
                if (pdfUrl) {
                    URL.revokeObjectURL(pdfUrl);
                }
            };
        
        }, [props.allInfos,props.columnShow,props.recapShow]);
        
    useEffect(() => {
        if(props.allInfos && props.setBtnDowloadPdfButtonModal && pdfBase64){
            props.setBtnDowloadPdfButtonModal(<DownloadPdfButton {...props} downloadPDF={downloadPDF}/>)
        }
    },[props.allInfos,props.columnShow,props.recapShow,pdfBase64])

     const downloadPDF = () => {
        // Création du blob à partir du base64
        const byteCharacters = atob(pdfBase64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
    
        // Création du lien de téléchargement
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = props.allInfos.bar;
        link.click();
    
        // Nettoyage
        URL.revokeObjectURL(link.href);
    };

    const DownloadPdfButton = (props) => {
        return(<div className='d-flex align-items-center ms-auto'>
            <button
                className='btn btn-success btn-sm'
                onClick={() => props.downloadPDF()}
            >
                {t('dlThePdf')}
            </button>
            {(props.from=='main') &&
                <>
                    &nbsp;&nbsp;&nbsp;&nbsp;

                    <PreviousNextBtn
                        previousNextValid={props.previousNextValid}
                        setItemsBilling={props.setItemsBilling}
                        allInfos={props.allInfos}
                        setAllInfos={props.setAllInfos}
                        setLoadingPrevNext={props.setLoadingPrevNext}
                        callBackConstruct={props.callBackConstruct}
                        setNoReloadNeeded={props.setNoReloadNeeded}
                        setDatasPdf={props.setDatasPdf}
                    />
                </>
            }
        </div>)
    }
    
    return (
        <div className={(props.from=='modal') ? 'mt-3' : ''}>
            {props.loadingPrevNext ? <div className='superpositionLoaderErp'><Loading></Loading></div> : false}
            <Tabs defaultActiveKey="consult" className='position-relative' id="uncontrolled-tab-example" onSelect={tabSelect}>
                <Tab eventKey="consult" title="Document">
                    {(props.from=='main') ? //si on est sur la version main
                        <CardPerso header={
                            <span className='d-flex'>
                                {withLogoHeader(
                                    props.allInfos.type,
                                    t(props.allInfos.type) + ' ' + props.allInfos.bar
                                )}

                                <DownloadPdfButton {...props} downloadPDF={downloadPDF}/>
                            </span>
                        }>
                            <Contain moduleFacturation={moduleFacturation} downloadPDF={downloadPDF} iframeRef={iframeRef} {...props} />                        
                        </CardPerso>

                        : //si on est sur la version modal
                        <Contain moduleFacturation={moduleFacturation} downloadPDF={downloadPDF} iframeRef={iframeRef} {...props} />
                    }
                    
                </Tab>
                {props.allInfos.type!='billingDeposit' &&
                    <Tab eventKey="detail" title={t('dataTable')}>
                        {loadingDetail ? <Loading /> :
                            (props.allInfos.type=='purchaseOrderB2b') ?
                                <Suspense fallback={<Loading></Loading>} >
                                    <DetailTableDocPo  allInfos={props.allInfos} id={props.id} setItemsBilling={props.setItemsBilling} setAllInfos={props.setAllInfos}/>
                                </Suspense>
                            :
                                (props.allInfos.type=='returnNote') ?
                                    <Suspense fallback={<Loading></Loading>} >
                                        <DetailTableDocReturnNote  allInfos={props.allInfos} id={props.id} />
                                    </Suspense>
                            :
                                (props.allInfos.type!='returnNote' && props.allInfos.type!='purchaseOrderB2b') ?
                                    <Suspense fallback={<Loading></Loading>} >
                                        <DetailTableDoc  allInfos={props.allInfos} id={props.id} setItemsBilling={props.setItemsBilling} setAllInfos={props.setAllInfos} setBrownDocumentModal={props.setBrownDocumentModal}/>
                                    </Suspense>
                            :
                                false
                        }
                    </Tab>
                }
                {props.allInfos.type=='purchaseOrderB2b' &&
                    <Tab eventKey="reliquat" title={t('gestionReliquats')}>
                       <Suspense fallback={<Loading></Loading>} >
                            <ReliquatTableDocPo
                                document={props.allInfos}
                                id={props.id}
                                reload={reloadReliquat}
                            />
                        </Suspense>
                    </Tab>
                }
                {(props.from=='main') &&
                    <Tab eventKey="search" title={t('tableSearch')}>
                        {Object.keys(props.allInfos).length!=0 &&
                            <SearchBilling 
                                createdDate={props.allInfos.date_finalisation}
                                documentType={props.allInfos.type}
                                infoClient={props.allInfos.client}
                                companyId={props.allInfos.other_company_id!=null ? props.allInfos.other_company_id : 'null'}
                            />
                        }
                    </Tab>
                }
            </Tabs>
        </div>
    )
};

export default ViewDetailDocument;
